
import {getNameByCode,getCodeByName} from './CodeShorDic'

let errorInfo = ''

// 每两位截取字符串并处理
function splitStringByTwo(input){
  let substrings = []
  for (let i = 0; i < input.length; i += 2) {
    let endIndex = i + 2
    if(endIndex > input.length){
      endIndex = input.length
    }
    substrings[i/2]=input.substring(i, endIndex)
  }
  return substrings
}
function shorten(code) {
  let s="";
  if (code.length % 2 == 1){
    errorInfo = '码长度必须为双数'
    console.log("码长度必须为双数.");
  }
  let strings=splitStringByTwo(code);
  strings.forEach(string=>{

    s+= getNameByCode(string);
  })
  return s;
}
function convertShortNum(codes = []){
  console.log('codes==>',codes)
  let result = '$$'
  let trueString = ''
  for (const codesKey in codes) {
    const code = codes[codesKey]
    if(codesKey == 0){
      trueString = code
      const s = code
      trueString += ","
      result += s + ","
    }else{
      if(codesKey == 1){
        const pl = code.substring(0,10)
        result += pl + ",";
        trueString += pl + ",";
      }
      if(codesKey >= 1){
        const ll = code.substring(10, 20);
        result += shorten(ll);
        trueString += ll;
      }
    }
  }
  return result
}

const testConvertShortNum = () =>{
  const testArr = ["83431041893468421358","83431033530259874393","83431033530259998818",
    "83431033530260355774","83431033530260470253","83431033530260839967","83431033530260953897",
    "83431033530261436356","83431033530261556749","83431033530261912831","83431033530262030397",
    "83431033530262395743","83431033530262517709","83431033530262872380","83431033530262997615",
    "83431033530263352098","83431033530263470409","83431033530264078237","83431033530264192665",
    "83431033530264554238","83431033530264677488"]

  const result = convertShortNum(testArr)
  console.log('短码前：')
  console.log(testArr)
  console.log('短码后：')
  console.log(result)
}

const testResetCodes = (strs) =>{
  console.log('短码=》')
  strs = '$$83431041893468421358,8343103353,c+.Q?c+“/rc-I]=c-Uc|c-7“#c-？L；c{Q<[c{;#Wc{】BEc}dd；c}M]Qc}Y1jc}.w4c}“`oc<It‘c<Uejc>h6Kc>sz@c>;PLc>#=/'
  console.log(strs)
  console.log('转换回来')
  const data = resetCodes(strs)
  console.log(data)
}
const resetCodes = (strs)=>{
  let firstCode="";
  let fll="";
  let fullCodes="";
  let s=strs.split(",");
  firstCode=s[0].substring(2,s[0].length);
  fll=s[1];
  fullCodes=reset(s[2]);
  let list = []
  list.push(firstCode);
  for (let i = 0; i < fullCodes.length/10; i++) {
    let codes=fullCodes.substring(i*10,(i+1)*10);
    list.push(fll+codes);
  }
  return list;
}
const reset = (code) => {
  let s = "";
  code.split('').forEach(b=>{
    s+=getCodeByName(b + '');
  })
  return s;
}

export {convertShortNum,resetCodes,testConvertShortNum,testResetCodes}